import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import AccommodationInputText from '../../accommodations/Components/AccommodationInputText';

import type { BookingContainer } from '../bookingsSlice';

interface CustomerNoteModalProps {
  show: boolean;
  onHide: () => void;
  titleText: string;
  closeText: string;
  saveText: string;
  bookingContainer: BookingContainer | null | undefined;
  bookingId: string | null;
  noteId: string | null;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    bookingId: string | null,
    noteId: string | null,
  ) => void;
  onSave: (
    event: React.MouseEvent<HTMLButtonElement>,
    bookingId: string | null,
    noteId: string | null,
  ) => void;
}

const CustomerNoteModal: React.FC<CustomerNoteModalProps> = ({
  show,
  onHide,
  titleText,
  closeText,
  saveText,
  bookingContainer,
  bookingId,
  noteId,
  onChange,
  onSave,
}) => {
  const inputId = noteId ?? 'customerBookingNote';

  const inputValue = (() => {
    const b = bookingContainer?.bookingResponses?.find(
      bo => bo.id?.toLowerCase() === (bookingId ?? '').toLowerCase(),
    );
    const n = b?.customerBookingNotes?.find(
      noi => noi.id?.toLowerCase() === (noteId ?? '').toLowerCase(),
    );
    return n?.noteText ?? '';
  })();

  // Keep local state to avoid caret jumping when parent state re-renders
  const [localNote, setLocalNote] = useState<string>(inputValue);

  // Sync local state when opening modal or switching targeted note
  useEffect(() => {
    if (show) {
      setLocalNote(inputValue);
    }
    // We intentionally depend on show, bookingId, noteId, and inputValue
  }, [show, bookingId, noteId, inputValue]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{titleText}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-24 py-24 px-lg-40">
        <AccommodationInputText
          HandleChange={e => {
            setLocalNote(e.target.value);
            onChange(e, bookingId, noteId);
          }}
          InputId={inputId}
          InputValue={localNote}
          IsTextarea
          LabelText={titleText}
          InputName="NoteText"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {closeText}
        </Button>
        <Button
          variant="primary"
          onClick={e => {
            onSave(e, bookingId, noteId);
          }}
        >
          {saveText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerNoteModal;
export { CustomerNoteModal };
